import React from "react";
import img1 from '../../assets/images/pexels-pixabay-534220.jpg';

const Detail = () => {
  return (
    <section className="relative pt-16 bg-blueGray-50">
      <div className="container mx-auto">
        <div className="flex flex-wrap items-center">
          <div className="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-4 mr-auto ml-auto -mt-78">
            <div
              className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg"
              style={{ backgroundColor: 'deepskyblue' }}
            >
              <img
                alt="LABH Industries"
                src={img1}
                className="w-full align-middle rounded-t-lg"
                loading="lazy"
              />
              <blockquote className="relative p-8" style={{ backgroundColor: 'deepskyblue' }}>
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  className="absolute left-0 w-full block h-[95px] -top-[94px]"
                >
                  <polygon
                    points="-30,95 583,95 583,65"
                    className="text-blue-500 fill-current"
                  ></polygon>
                </svg>
                <h4 className="text-xl font-bold text-white">
                  Driven by Passion. Powered by Expertise.
                </h4>
                <p className="text-md font-light mt-2 text-white">
                  At LABH Industries, our strength lies in a passionate and expert workforce delivering world-class EPC solutions and equipment across industries with a strong commitment to quality, safety, and on-time delivery.
                </p>
              </blockquote>
            </div>
          </div>

          <div className="w-full md:w-6/12 px-4">
            <div className="flex flex-wrap">
              <div className="w-full md:w-6/12 px-4">
                <div className="relative flex flex-col mt-4">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                      <i className="fas fa-industry"></i>
                    </div>
                    <h6 className="text-xl mb-1 font-semibold">
                      Complete EPC & Infrastructure Solutions
                    </h6>
                    <p className="mb-4 text-blueGray-500">
                      From modular fabrication and containerized structures to roads and buildings—our EPC services span every need, ensuring efficient project delivery.
                    </p>
                  </div>
                </div>
                <div className="relative flex flex-col min-w-0">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                      <i className="fas fa-shipping-fast"></i>
                    </div>
                    <h6 className="text-xl mb-1 font-semibold">
                      Global Reach, Local Expertise
                    </h6>
                    <p className="mb-4 text-blueGray-500">
                      We handle export projects with precision—structural frame fabrication, packing, and seamless overseas delivery.
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-6/12 px-4">
                <div className="relative flex flex-col min-w-0 mt-4">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                      <i className="fas fa-building"></i>
                    </div>
                    <h6 className="text-xl mb-1 font-semibold">
                      Diverse Industry Applications
                    </h6>
                    <p className="mb-4 text-blueGray-500">
                      From factories and offices to hotels, institutions, hospitals, and supermarkets—our structures elevate infrastructure across all sectors.
                    </p>
                  </div>
                </div>
                <div className="relative flex flex-col min-w-0">
                  <div className="px-4 py-5 flex-auto">
                    <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                      <i className="fas fa-tools"></i>
                    </div>
                    <h6 className="text-xl mb-1 font-semibold">
                      One-Stop Integrated Services
                    </h6>
                    <p className="mb-4 text-blueGray-500">
                      With top-tier people, equipment, and infrastructure—we offer end-to-end solutions under one roof, making projects faster and smoother.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Detail;
